import React, {forwardRef, useImperativeHandle} from "react";
import {Descriptions} from "antd";

const Default = (props, ref) => {
  const { account } = props;

  useImperativeHandle(ref, () => null);

  return (
    <Descriptions bordered title={account.alias}>
      <Descriptions.Item label="Lana URL" span={3}>
        <a href={account.url} target="_blank" rel="noopener noreferrer">
          {account.url}
        </a>
      </Descriptions.Item>
      <Descriptions.Item label="Lana REF" span={3}>
        {account.ref}
      </Descriptions.Item>
    </Descriptions>
  )
};

export default forwardRef(Default);